import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { get, post } from "../../../utils/HttpRequest";
import config from "../../../config/config.json";
import { Toast } from "primereact/toast";
import { Button, Form, Col, Row } from "react-bootstrap";

const AssessmentThresholdMessageForm = () => {
  const toast = useRef(null);
  const formRef = useRef();
  const [validated, setValidated] = useState(false);
  const [thresholdMessage, setThresholdMessage] = useState("");
  const [group, setGroup] = useState("");

  const getThresholdMessage = async () => {
    try {
      const url = config.api.url + "getTrialConfig/messageForAssessmentScoreThreshold";
      get(url).then((response) => {
        if(response && response.data){
            let valueData = response.data;
            setThresholdMessage(valueData.value);
            setGroup(valueData.group);
        }
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getThresholdMessage();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      event.stopPropagation();
      return;
    }
    try {
      const formData = {
        name: 'messageForAssessmentScoreThreshold',
        value: form.thresholdMessage.value,
      };
      var url = config.api.url + "updateTrialConfig";
      post(url, formData)
        .then((response) => {
          if (response.status === 201 || response.status === 200) {
            toast.current.show({
              severity: "success",
              summary: "Assessment threshold message has been updated",
              detail: "Success",
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "something went wrong",
              detail: "something went wrong",
            });
          }
        })
        .catch(function (error) {
          if (error.response.status === 400 || error.response.status === 401) {
            toast.current.show({
              severity: "error",
              summary: "something went wrong",
              detail: "something went wrong",
            });
          }
        });
      setValidated(false);
    } catch (error) {
      console.error("Error while making API call:", error);
    }
  };

  return (
    <div className="app">
      <Toast ref={toast}></Toast>
      <hr />
      <Row>
        <Col lg={12}>
          <span className="card-title">Set Message for Assessment Score Threshold</span>
          <p className="px-2">
            Set the message to display when assessment score threshold is not passed
          </p>
          <Form
            id="settingsPageThresholdMessage"
            className="needs-validation"
            onSubmit={handleSubmit}
            noValidate
            ref={formRef}
            validated={validated}
          >
            <div className="col-sm-12 col-md-6 mb-3 mt-3">
              <Form.Group>
                <Form.Control
                  as="textarea"
                  className="form-control input-group"
                  name="thresholdMessage"
                  rows="4"
                  required
                  value={thresholdMessage}
                  onChange={(e) => setThresholdMessage(e.target.value)}
                />
              </Form.Group>
            </div>

            <div className="form-actions ml-2 mb-4">
              <Button className="btn btn-primary px-3" type="submit">
                Save
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default AssessmentThresholdMessageForm;